export const userViewEditAddress = () => ({
  type: 'View Edit Delivery Address page',
});

export const updateAddress = () => ({
  type: 'Update delivery address',
});
